import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { HttpBadStatusCodeError } from '@cian/peperrors';
import { ESourcePage } from 'shared/repositories/newbuilding-consultants/entities/get_or_create_chat/V1GetOrCreateChatRequest';
import { ISyncChat } from 'shared/repositories/newbuilding-consultants/entities/sync_chat/SyncChat';
import {
  fetchGetOrCreateChat,
  TGetOrCreateChatResponse,
} from 'shared/repositories/newbuilding-consultants/v1/get-or-create-chat';

interface IConsultantChatProps {
  httpApi: IHttpApi;
  logger: ILogger;
  parameters: {
    pageUrl?: null | string;
    sourcePage: ESourcePage;
  };
}

export const fetchConsultantCianChat = async ({
  httpApi,
  logger,
  parameters,
}: IConsultantChatProps): Promise<ISyncChat | null> => {
  try {
    const data: TGetOrCreateChatResponse = await fetchGetOrCreateChat({
      httpApi,
      parameters,
    });

    if (data.statusCode !== 200) {
      throw new HttpBadStatusCodeError({
        statusCode: data.statusCode,
        domain: 'resolveConsultantChat',
        message: data.response.message as string,
      });
    }

    return data.response.chat || null;
  } catch (error) {
    logger.error(error, {
      domain: 'fetchConsultantCianChat',
    });

    return null;
  }
};
